<section class="mb-3">

  <div matBadge="{{data.messages.length}}" matBadgeOverlap="false" matBadgeColor="warn" matBadgePosition="after"></div>

<mat-expansion-panel #panel>

  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="d-flex flex-row justify-content-between w-100 align-items-center">
        <div *ngIf="!isPanelExpanded()" class="h6 d-block d-sm-none text-nowrap">
          {{get25(data.key)}}
        </div>
        <div *ngIf="isPanelExpanded()" class="h6 d-block d-sm-none">
          {{data.key}}
        </div>
        <div class="h6 d-none d-sm-block">{{data.key}}</div>
        <div>
          <button (click)="deleteAll($event)" class="h6 d-none d-sm-block"
                  mat-icon-button
                  i18n-aria-label aria-label="Zmazať všetky notifikácie skupiny"
                  i18n-title title="Zmazať všetky notifikácie skupiny">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div>
    <ul>
      <app-message-item *ngFor="let m of data.messages"
                        [message]="m"
                        (onMessageDeleted)="afterMessageDeleted($event)">
      </app-message-item>
    </ul>
  </div>

</mat-expansion-panel>

</section>
